import { CountMessage } from './../../services/menu.service';
import { MenuService } from 'app/services/menu.service';

import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-count',
    templateUrl: './count.component.html',
    styleUrls: ['./count.component.scss'],
    standalone: false
})
export class CountComponent implements OnInit, OnDestroy
{
	@Input() endpoint: string;

	constructor
	(
		private menuService: MenuService
	) { }

	loading: boolean = false;
	count: number = 0;

	ngOnInit()
	{
		const menuCountMessageSubscription = this.menuService.countMessage.subscribe(
			(message:CountMessage) =>
			{
				if (message.endpoint && message.endpoint==this.endpoint) {
					// console.log("count message received ", message);
					this.count = message.count;
				}
			}
		);
		this.subscriptions.push(menuCountMessageSubscription);
	}

	subscriptions: Subscription[] = [];
	ngOnDestroy() 
	{
		this.subscriptions.forEach((subscription) => {
			subscription.unsubscribe();
		});
	}
}